import React from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';
import { SUBTYPES, TYPES } from './constants';

const popupPages = ({ className, caption, onClick, active }) => {
  const classes = [className, active ? 'active' : ''];

  return (
    <li className={classes.join(' ')} onClick={onClick}>
      {caption}
    </li>
  );
};

const PopupPage = styled(popupPages)`
  color: #ffffff;
  font-size: 1em;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  margin: auto;
  height: 52px;
  align-items: center;
  text-align: center;
  justify-content: center;
  width: 100px;
  border-right: 1px solid #ffffff;

  &.active {
    background-color: white;
    color: rgb(82, 82, 82);
  }
`;

export const PopupPageSelector = ({ goal, type }) => {
  const [activeGamificationPage, setActiveGamificationPage] = React.useState(
    window.$RENDERED_ELEMENT?.preview_page || window.$RENDERED_ELEMENT?.settings?.preview_page || 'main'
  );
  const history = useHistory();
  const popupMatch = useRouteMatch('/sites/:siteId/popups/:popupId/:type');
  const formMatch = useRouteMatch('/sites/:siteId/forms/:formId/:type');
  const match = popupMatch || formMatch;
  const isForm = !!formMatch;
  const basePath = isForm ? 'forms' : 'popups';
  const currentType = match?.params?.type;
  const siteId = match?.params?.siteId;
  const popupId = match?.params?.popupId || match?.params?.formId || 'new';
  const isGamification = goal === SUBTYPES.GAMIFICATION;
  const showConversion =
    isForm ||
    (!isGamification &&
    [
      SUBTYPES.EMAIL,
      SUBTYPES.WEBFORM,
      SUBTYPES.RETIREMENT,
      SUBTYPES.LEADFORM,
    ].includes(goal));
  const showQuestion =
    [SUBTYPES.EMAIL, SUBTYPES.TRAFFIC, SUBTYPES.CALL].includes(goal) &&
    [TYPES.BAR, TYPES.MODAL, TYPES.SLIDER, TYPES.TAKEOVER].includes(type);
  const pages = [
    ...(showQuestion
      ? [{ id: 'question', linkId: 'question', caption: 'Yes/No' }]
      : []),
    { id: 'main', linkId: 'design', caption: isForm ? 'Form' : 'Popup' },
    ...(isGamification
      ? [
          { id: 'claim', linkId: 'design', caption: 'Post Play' },
          { id: 'winning', linkId: 'design', caption: 'Winning' },
          { id: 'losing', linkId: 'design', caption: 'Losing' },
        ]
      : []),
    ...(showConversion
      ? [{ id: 'thank-you', linkId: 'conversion', caption: 'Success' }]
      : []),
  ];

  const onClick = (id, linkId) => {
    history.push(`/sites/${siteId}/${basePath}/${popupId}/${linkId}`);
    // For gamification, all pages live under the same editor step.
    if (isGamification) {
      const hb = window.hellobar;
      const popup = hb?.popups?.[0];

      // The "Popup" tab is the play experience for gamification.
      if (id === 'main') {
        // Reset preview state so user can see email + wheel.
        popup?.setValue?.('gamification_email_collected', '0');
        popup?.setValue?.('gamification_result', '');
      }

      // Default: delegate to runtime page switcher.
      setActiveGamificationPage(id);
      hb?.displayPage?.(id);
    }
  };

  const isActive = (page) => {
    // Non-gamification: active follows the editor step route.
    if (!isGamification) {
      return (
        (['goal', 'type', 'design', 'settings', 'targeting', 'trigger', 'campaign'].includes(
          currentType
        ) &&
          page.id === 'main') ||
        (currentType === 'question' && page.id === 'question') ||
        (currentType === 'conversion' && page.id === 'thank-you')
      );
    }

    // Gamification: keep tab highlight in sync with local state.
    return activeGamificationPage === page.id;
  };

  return (
    <>
      {window.hellobar?.popups?.length > 0 && (
        <ul className="popup-page-selector">
          {pages.map((page) => (
            <PopupPage
              key={page.id}
              caption={page.caption}
              onClick={() => onClick(page.id, page.linkId)}
              active={isActive(page)}
            />
          ))}
        </ul>
      )}
    </>
  );
};
